import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { RoutePath } from '@business/seller';
import { ConnectionPaths } from '@business/seller/src/paths';
import { i18n } from '@ecom-alliance/libs';
import { SellerAccountStatus } from '@/api/affiliate/data/account';
export * from './contact-info';
export * from './request';
export * from './profile-formatter';
export var PairSourceEnum = /*#__PURE__*/function (PairSourceEnum) {
  PairSourceEnum["AUTHOR_RECOMMEND"] = "author_recommend";
  PairSourceEnum["AUTHOR_SEARCH"] = "author_search";
  PairSourceEnum["AUTHOR_RANKING_LISTS"] = "author_ranking_lists";
  PairSourceEnum["AUTHOR_FILTER"] = "author_filter";
  return PairSourceEnum;
}({});
export var getElement = function getElement(defaultElement, target) {
  var targetElement = null;
  if (typeof target === 'string') {
    targetElement = document.querySelector(target);
  } else {
    targetElement = target || defaultElement;
  }
  return targetElement || defaultElement;
};
export var getCreatorProfilePagePath = function getCreatorProfilePagePath(_ref) {
  var pairSource = _ref.pairSource,
    cid = _ref.cid,
    enterFrom = _ref.enterFrom,
    searchKey = _ref.searchKey,
    rankFilter = _ref.rankFilter,
    reqId = _ref.reqId,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? '' : _ref$query;
  var urlSearch = new URLSearchParams(_objectSpread({
    cid: cid !== null && cid !== void 0 ? cid : '',
    pair_source: pairSource !== null && pairSource !== void 0 ? pairSource : '',
    enter_from: enterFrom !== null && enterFrom !== void 0 ? enterFrom : '',
    search_key: searchKey !== null && searchKey !== void 0 ? searchKey : '',
    req_id: reqId !== null && reqId !== void 0 ? reqId : '',
    query: query
  }, rankFilter ? {
    rank_filter: rankFilter !== null && rankFilter !== void 0 ? rankFilter : ''
  } : {}));
  return RoutePath.ConnectionPaths.CREATOR_DETAIL + "?" + urlSearch.toString();
};
export var encodeLeaderboardFilter = function encodeLeaderboardFilter(filter) {
  return filter ? btoa(JSON.stringify(filter)) : '';
};
export var decodeLeaderboardFilter = function decodeLeaderboardFilter(filter) {
  if (!filter) {
    return undefined;
  }
  try {
    return JSON.parse(atob(filter));
  } catch (_unused) {
    return undefined;
  }
};
export var getCreatorLeaderboardPagePath = function getCreatorLeaderboardPagePath(_ref2) {
  var filter = _ref2.filter,
    enterFrom = _ref2.enterFrom;
  var urlSearch = new URLSearchParams({
    rank_filter: filter !== null && filter !== void 0 ? filter : '',
    enter_from: enterFrom !== null && enterFrom !== void 0 ? enterFrom : ''
  });
  return ConnectionPaths.CREATOR_LEADERBOARD + "?" + urlSearch.toString();
};
export var getProductUrl = function getProductUrl(_ref3) {
  var shopCenterDomain = _ref3.shopCenterDomain,
    productId = _ref3.productId,
    region = _ref3.region,
    locale = _ref3.locale;
  return shopCenterDomain + "/view/product/" + productId + "?region=" + region + "&locale=" + locale;
};
export var getOperationConfigBySellerStatus = function getOperationConfigBySellerStatus(account) {
  var _ref4 = account.currentShopInfo || {},
    is_limited_by_gne = _ref4.is_limited_by_gne,
    shop_close_info = _ref4.shop_close_info;
  var _ref5 = shop_close_info || {},
    seller_account_status = _ref5.seller_account_status;
  if (is_limited_by_gne) {
    return {
      INVITE_ENTRY_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_restricted_create_disable', 'You can restricted to create new collaborations due to recent violations.');
        }
      },
      ADD_CREATOR_BUTTON_AND_INPUT: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_restricted_add_creator_disable', 'You are restricted to add creators due to recent violations.');
        }
      },
      ADD_PRODUCT_FROM_SHOP_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_restricted_add_product_disable', 'You are restricted to add products due to recent violations.');
        }
      },
      CREATE_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_restricted_create_disable', 'You can restricted to create new collaborations due to recent violations.');
        }
      },
      EDIT_BUTTON: {
        isDisabled: false
      },
      SHARE_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_gne_share', "You can't share this collaboration because you fail to meet affiliate entrance eligibility");
        }
      },
      DUPLICATE_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_gne_duplicate', "You can't duplicate this collaboration because you fail to meet affiliate entrance eligibility");
        }
      }
    };
  }
  if (seller_account_status === SellerAccountStatus.CLOSING) {
    return {
      INVITE_ENTRY_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closing_create', "You can't create new collaboration because shop is closing");
        }
      },
      ADD_CREATOR_BUTTON_AND_INPUT: {
        isDisabled: true
      },
      ADD_PRODUCT_FROM_SHOP_BUTTON: {
        isDisabled: true
      },
      CREATE_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closing_create', "You can't create new collaboration because shop is closing");
        }
      },
      EDIT_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closing_edit_disable', "You can't edit collaborations due to the shop is in process of closing.");
        }
      },
      SHARE_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closing_share', "You can't do anything to this collaboration because your shop is closing");
        }
      },
      DUPLICATE_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closing_share', "You can't do anything to this collaboration because your shop is closing");
        }
      }
    };
  }
  if (seller_account_status === SellerAccountStatus.WITHDRAW) {
    return {
      INVITE_ENTRY_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closed_share_create', "You can't create new collaboration because shop is closed");
        }
      },
      ADD_CREATOR_BUTTON_AND_INPUT: {
        isDisabled: true
      },
      ADD_PRODUCT_FROM_SHOP_BUTTON: {
        isDisabled: true
      },
      CREATE_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closing_create', "You can't create new collaboration because shop is closing");
        }
      },
      EDIT_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closed_edit_disable', "You can't edit collaborations due to the shop is closed.");
        }
      },
      SHARE_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closed_share_duplicate', "You can't do anything to this collaboration because your shop is closed");
        }
      },
      DUPLICATE_BUTTON: {
        isDisabled: true,
        getDisabledTooltip: function getDisabledTooltip() {
          return i18n.t('affiliate_target_invitation_seller_abnormal_closed_share_duplicate', "You can't do anything to this collaboration because your shop is closed");
        }
      }
    };
  }
  return {};
};